import Layout from "@/components/Layout";
import { SERVICES } from "@/data/content";
import { motion } from "framer-motion";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const openDemo = () => window.dispatchEvent(new CustomEvent("alphatech:open-demo"));

export default function Services() {
  return (
    <Layout>
      <section className="relative pt-16 pb-20">
        <div className="absolute inset-0 hero-glow opacity-60" aria-hidden />
        <div className="absolute inset-0 grid-bg opacity-30" aria-hidden />
        <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
          <div className="overline">Services</div>
          <h1 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter leading-[1.05] max-w-4xl" data-testid="services-title">
            The complete <span className="text-gradient-blue">iGaming tech stack</span>.
          </h1>
          <p className="mt-5 text-gray-400 max-w-2xl leading-relaxed">
            Every layer of a modern iGaming operation — platform, aggregation, payments, integrations and managed services — engineered in-house.
          </p>
        </div>
      </section>

      <section className="pb-24">
        <div className="mx-auto max-w-7xl px-6 lg:px-10 space-y-6">
          {SERVICES.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.05 }}
              className={`grid grid-cols-1 lg:grid-cols-12 gap-6 p-8 lg:p-10 rounded-3xl bg-[#0B1224]/70 border border-white/10 ${i % 2 === 1 ? "lg:pl-16" : ""}`}
              data-testid={`services-item-${i}`}
            >
              <div className="lg:col-span-2">
                <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-[#2563EB]/25 to-[#7C3AED]/20 border border-[#2563EB]/30 flex items-center justify-center">
                  <s.icon className="w-6 h-6 text-[#00D4FF]" />
                </div>
                <div className="mt-3 text-xs uppercase tracking-[0.2em] text-gray-500">0{i + 1}</div>
              </div>
              <div className="lg:col-span-7">
                <h2 className="font-display text-2xl sm:text-3xl font-bold tracking-tight">{s.title}</h2>
                <p className="mt-3 text-gray-400 leading-relaxed">{s.desc}</p>
                <ul className="mt-5 grid sm:grid-cols-2 gap-y-2 gap-x-6">
                  {["Custom branding & CMS", "Dedicated account manager", "Analytics & reporting", "24/7 engineering support"].map((f) => (
                    <li key={f} className="flex items-start gap-2 text-sm text-gray-300">
                      <CheckCircle2 className="w-4 h-4 mt-0.5 text-[#00D4FF]" /> {f}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="lg:col-span-3 flex lg:justify-end lg:items-end">
                <Button
                  onClick={openDemo}
                  data-testid={`services-cta-${i}`}
                  className="btn-glow bg-[#2563EB] hover:bg-[#1d4ed8] rounded-full h-11 px-6"
                >
                  Book Consultation <ArrowRight className="ml-2 w-4 h-4" />
                </Button>
              </div>
            </motion.div>
          ))}
        </div>
      </section>
    </Layout>
  );
}
